import { render, staticRenderFns } from "./NewExams.vue?vue&type=template&id=9ff8546a&scoped=true"
import script from "./NewExams.vue?vue&type=script&lang=js"
export * from "./NewExams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ff8546a",
  null
  
)

export default component.exports